exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n  margin-top: 50px;\n}\n@media screen and (max-width: 560px) {\n.wrapper {\n    margin-top: 100px;\n}\n}\n.sidebar-toggle {\n  margin-left: 10px;\n}\n", ""]);

// exports
